<template>
  <div @click="handleSelectProduct(product)" class="font-poppins group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 cursor-pointer" :class="{ 'bg-opacity-100': !isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1 shadow-md': isSelectedProduct }">
    <div class="transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none" :class="[isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']">
      <div class="absolute h-40 right-10 inset-y-12">
        <img class="absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300" :src=product.img />
        <img class="absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300" :src=product.imghover />
      </div>
      <h3 class="text-xl font-semibold text-black py-0 my-0">Talk {{ utilityService.toTitleCase(product.name) }}</h3>
      <p class="mt-0 lg:mt-2 flex items-baseline text-gray-900 py-0 my-0">
        <span class="text-5xl font-extrabold tracking-tight font-poppins-bold">${{ product.price }}</span>
        <span class="ml-1 text-lg font-normal text-gray-900">/Month</span>
      </p>

      <!-- Feature list -->
      <ul role="list" class="mb-2 space-y-6 px-0 my-0 py-0">
        <li class="flex my-0 py-0">
          <span class="text-black">{{ product.description }}</span>
        </li>
      </ul>
      <div class="mt-6 max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md">
          <button class=" cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none" :class="[isSelectedProduct? 'bg-transparent' : 'bg-white']">
              {{ isSelectedProduct ? 'Selected' : 'Select Product'}}
          </button>
      </div>
      <a v-for="standardLink in standardLinks" :key="standardLink.name" :href="standardLink.link" target="_blank" class="block href font-bold text-black hover:text-brand-primary hover:underline transition duration-250 mt-6 text-sm">
        {{ standardLink.name }}
      </a>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '../../services/utilityServiceInterface';
import { defineProps, defineEmits } from 'vue';
import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  img?: string,
  imghover?: string
}

defineProps<{
  isSelectedProduct: boolean
  product: Product
}>();

const emit = defineEmits<{(event: 'handle-select-product', product: Product): void}>();

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const standardLinks: Array<{ name: string, link: string }> = [{
  name: 'Critical Information Summary',
  link: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${brandService.getName()}/critical-information-summary-phone.pdf`
}];
</script>
